import * as React from 'react';
import { RequireNewPassword } from 'aws-amplify-react';

import { PasswordRequirements } from './password-requirements';
import { withSectionBodyNotes } from './section-body-notes';
import { renderStockScreen } from './stock-screen';

const NEW_PASSWORD_INPUT = 'require-new-password-new-password-input';

/**
 * The stock Amplify v3 Change Password screen (shown when Cognito forces a
 * password change) with the password policy spelled out under the field.
 */
export class LabSmartsRequireNewPassword extends RequireNewPassword {
  showComponent(theme: any): JSX.Element {
    return withSectionBodyNotes(
      renderStockScreen(this, RequireNewPassword, () => super.showComponent(theme)),
      'require-new-password-body-section',
      fields => {
        const passwordIndex = fields.findIndex(child => {
          const element = child as React.ReactElement<any>;
          return (
            !!element && !!element.props && element.props['data-test'] === NEW_PASSWORD_INPUT
          );
        });
        if (passwordIndex < 0) {
          return null;
        }

        const annotated = fields.slice();
        annotated.splice(
          passwordIndex + 1,
          0,
          <PasswordRequirements key="ls-password-requirements" />,
        );
        return annotated;
      },
    ) as JSX.Element;
  }
}
